import React, { FormEvent, Fragment, useContext, useEffect, useState } from "react";
import { Table, Container, Tab, Menu, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import BogStore from "../../../app/stores/bogStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link } from "react-router-dom";
import BogListByDate from "./BogListByDate";
import BogListByTechnician from "./BogListByTechnician";

const BogDashboard: React.FC = () => {
  const bogStore = useContext(BogStore);
  const { loadBogs, loadTechnicians, clearDisplay, clearPage, submitting, target } = bogStore;

  useEffect(() => {
    loadTechnicians().then(() => loadBogs());

    return () => {
      clearPage();
    };
  }, []);

  const [activeItem, setActiveItem] = useState("By Date");

  if (bogStore.loadingInitial)
    return <LoadingComponent content="Loading BOGs" />;

  return (
    <Container fluid> 
      <Menu widths={2} pointing attached='top'>
        <Menu.Item
          name='By Date'
          active={activeItem === 'By Date'}
          onClick={(e, {name}) => {setActiveItem(name!.toString()); clearDisplay();}}
        >
         { (activeItem === 'By Date') ? <strong style={{fontSize: 16}}>By Date</strong> : 
         <span style={{fontSize: 16}}>By Date</span>}
        </Menu.Item>
        <Menu.Item
          name='By Technician'
          active={activeItem === 'By Technician'}
          onClick={(e, {name}) => {setActiveItem(name!.toString()); clearDisplay();}}
        >
          { (activeItem === 'By Technician') ? <strong style={{fontSize: 16}}>By Technician</strong> : 
         <span style={{fontSize: 16}}>By Technician</span>}
        </Menu.Item>
      </Menu>
      <Segment attached='bottom'>
          {(activeItem === 'By Date') ? <BogListByDate/> : <BogListByTechnician/> }
        </Segment>
    </Container>
  );
};

export default observer(BogDashboard);
